export default __webpack_public_path__ + "static/media/Stage4_Runout.8bc18b96.svg";